import React from 'react';
import { Sparkles } from 'lucide-react';

type BlockRegenerateButtonProps = {
  visible: boolean;
  position: { top: number; left?: number; right?: number };
  onClick: () => void;
  disabled?: boolean;
};

export const BlockRegenerateButton: React.FC<BlockRegenerateButtonProps> = ({
  visible,
  position,
  onClick,
  disabled = false,
}) => {
  if (!visible) return null;

  return (
    <div
      contentEditable={false}
      className="pointer-events-none"
      style={{
        position: 'absolute',
        top: position.top,
        left: position.left,
        right: position.right,
        zIndex: 50,
        transition: 'opacity 150ms ease-in-out',
        opacity: visible ? 1 : 0,
      }}
    >
      <button
        type="button"
        data-testid="regenerate-section"
        aria-label="Regenerate section with AI"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onClick();
        }}
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        disabled={disabled}
        className="group pointer-events-auto inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-xs font-semibold text-white bg-gradient-to-r from-[#33b864] to-[#1f9e7f] shadow-[0_4px_14px_rgba(51,184,100,0.45)] ring-1 ring-white/30 hover:shadow-[0_6px_20px_rgba(51,184,100,0.6)] hover:-translate-y-0.5 active:translate-y-0 active:scale-95 transition-all duration-200 ease-out disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0 disabled:hover:shadow-[0_4px_14px_rgba(51,184,100,0.45)]"
        title="Regenerate this section with AI"
      >
        <Sparkles className="h-3.5 w-3.5 transition-transform duration-300 group-hover:rotate-12 group-hover:scale-110" />
        Regenerate
      </button>
    </div>
  );
};
